import { IReducerAction } from "../../interfaces/IRedux";
import {
  USER_LOADING,
  USER_END_LOADING,
  USER_LOADING_OPERATION,
  USER_END_LOADING_OPERATION,
  USER_GET_DATA,
  USER_ADD_SINGLE,
  USER_UPDATE_SINGLE,
  USER_REMOVE_SINGLE,
  USER_GET_SINGLE,
  USER_CLEAR,
} from "../types";

const initialState = {
  loading: false,
  loadingOperation: false,
  elements: [],
  item: null,
};

export default function reducer(state = initialState, action: IReducerAction) {
  const payload = action.payload || {};

  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        loading: true,
      };

    case USER_END_LOADING:
      return {
        ...state,
        loading: false,
      };

    case USER_LOADING_OPERATION:
      return {
        ...state,
        loadingOperation: true,
      };

    case USER_END_LOADING_OPERATION:
      return {
        ...state,
        loadingOperation: false,
      };

    case USER_GET_DATA:
      return {
        ...state,
        loading: false,
        elements: payload,
      };

    case USER_GET_SINGLE:
      return {
        ...state,
        loading: false,
        loadingOperation: false,
        item: payload,
      };

    case USER_ADD_SINGLE:
      if (payload && Object.keys(payload).length > 0) {
        // @ts-ignore
        const itemIndex = state.elements.findIndex((e) => e.id === payload.id);
        if (itemIndex < 0) {
          state.elements.splice(0, 0, payload);
        }
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case USER_UPDATE_SINGLE:
      if (payload && Object.keys(payload).length > 0) {
        // @ts-ignore
        const itemIndex = state.elements.findIndex((e) => e.id === payload.id);
        state.elements[itemIndex] = payload;
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case USER_REMOVE_SINGLE:
      if (payload && Object.keys(payload).length > 0) {
        // @ts-ignore
        const itemIndex = state.elements.findIndex((e) => e.id === payload.id);
        if (itemIndex >= 0) {
          state.elements.splice(itemIndex, 1);
        }
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case USER_CLEAR:
      return initialState;
    default:
      return state;
  }
}
